// Include Stylesheet
require("../../css/src/stylesheet.scss");

// Include Figure Base Resources
require("FigureBaseResources");

// Custom Site Stuff
require("./theme.js");

// Google Places Autocomplete
require("./place-autocomplete.js");

// Material Design
require("./material-design.js");

// Load via script tag:
// require('script-loader!./scroller.js')

// Expose a variable from a library:
// const scroller = require('expose-loader?scroller!./scroller.js')
